







































import {Component, Vue, Watch} from "vue-property-decorator";
import AlphabetList from "@/components/AlphabetList.vue";
import FilmListItem from "@/components/FilmListItem.vue";
import {Film} from "@/modules/Rhizome/interfaces/film.interface";
import {bus} from "@/plugins/bus";
import {localStorageService} from "@/services/local-storage.service";
import {rhizomeResource} from "@/modules/Rhizome/resources/rhizome.resource";
import {LocalStorageServiceConfig} from "@/interfaces/local-storage.interface";

@Component({
  components: {
    FilmListItem,
    AlphabetList
  }
})

export default class FilmList extends Vue {
  arrayFilms: Film.IFilm[] = [];
  filteredFilms: Film.IFilm[] = [];
  hoverIndex: any = null;
  clickIndex: any = null;
  connectionLines = [];
  connectedFilms = [];
  mediaQuery: any = null;
  isMobile: boolean = false;
  preActiveFilm: number = null;

  get showFavorites(): boolean {
    return this.$store.state.rhizome.showFavorites;
  }

  get isKiosk() {
    return this.$store.state.rhizome.kioskMode;
  }

  created() {
    this.preActiveFilm = this.$store.state.rhizome.preActiveFilm || null;
    this.prepareListFilms();
  }

  mounted() {
    window.addEventListener('resize', this.resizeEvent);
    this.mediaQuery = window.matchMedia("(min-width: 768px)");

    this.checkMedia(this.mediaQuery);

    bus.$on('filterList', (val) => {
      this.filteredFilms = this.filterList(val);
      this.clearLineConnections();
    });

    bus.$on('filterListKeyword', async ({keywordID, keywordValue}) => {
      if (keywordID && keywordValue) {
        localStorageService.pushHistory(
            {
              type: LocalStorageServiceConfig.HistoryItemTypes.KEYWORD,
              keyword: {
                entity_id: keywordID,
                keyword: keywordValue,
              },
            }
        );
      }

      let response = await rhizomeResource.getList(keywordID);
      this.$store.commit('rhizome/setPropertyInState', { name: 'filmsList', value: response });
      this.prepareListFilms();
      this.clearLineConnections();
    });

    bus.$on('searchToggle', (open) => {
      if (!open) this.filteredFilms = this.arrayFilms;
    });

    if (this.preActiveFilm) {
      const film = this.arrayFilms.find(film => film.id === this.preActiveFilm);
      if (film) {
        this.itemClick(film, this.arrayFilms.findIndex(item => item.id === film.id));
        setTimeout(() => this.scrollToTarget(this.preActiveFilm), 0);
      }
    }
  }

  prepareListFilms() {
    if (this.showFavorites) {
      this.arrayFilms = [];
      let favoriteList = localStorageService.getFavoriteList();
      if (favoriteList?.length) {
        this.arrayFilms = this.$store.state.rhizome.filmsList.filter(film => favoriteList.includes(film.id));
      }
    }
    else {
      this.arrayFilms = [...this.$store.state.rhizome.filmsList];
    }

    this.arrayFilms.sort((a, b) => a.titleSort.localeCompare(b.titleSort));
    this.filteredFilms = this.arrayFilms;
  }

  checkMedia(e) {
    e.matches ? this.isMobile = false : this.isMobile = true;
  }

  getFilmStatus(index) {
    let status: Film.FilmState;
    if (this.hoverIndex === index) status = Film.FilmState.HOVERED;
    if (this.clickIndex === index) status = Film.FilmState.ACTIVE;

    return status;
  }

  resizeEvent() {
    this.clearLineConnections();
  }

  filterList(val) {
    return this.arrayFilms.filter(film => (film.titleSort + ' ' + film.description).toLowerCase().indexOf(val.toLowerCase()) >= 0);
  }

  letterChange(index) {
    if (this.$store.state.rhizome.filterByKeywordName) return false

    const film = this.filteredFilms[index]
    const letter = film.titleSort.charAt(0).toLowerCase()

    // check if alphabetical
    if (!letter.match(/[a-z]/i)) {
      return false
    }

    if (index === 0 || this.filteredFilms.length === 0) return false

    const lastFilm = this.filteredFilms[index - 1]

    const lastLetter = lastFilm.titleSort.charAt(0).toLowerCase()

    if (letter !== lastLetter) {
      return true
    }

    return false
  }

  scrollToTarget(id) {
    let index  = this.findIndexByID(id);
    let element = this.$refs[`film-${index}`][0];
    let headerOffset = 100;
    let elementPosition = window.pageYOffset + element.getBoundingClientRect().top;
    let offsetPosition = elementPosition - headerOffset;

    window.scrollTo(0, offsetPosition);
  }

  addLines(film: Film.IFilm, index: number) {
    if (!film.connectionWith?.length) return;

    let mobileOffset = this.isMobile ? 15 : 0;
    let mobileAnimation = this.isMobile ? 400 : 0;
    let currentFilmIndex = index;
    let heroVideo = this.$refs[`film-${currentFilmIndex}`][0];
    let filmIndexes = film.connectionWith.map(item => this.findIndexByID(item.id)).filter(item => item >= 0);

    if (this.clickIndex !== null) this.connectedFilms.push(currentFilmIndex);

    if (filmIndexes.length) {
      filmIndexes.forEach(itemIndex => {
        if (this.clickIndex !== null) this.connectedFilms.push(itemIndex);
      });

      if (this.isMobile) {
        setTimeout(() => {
          this.drawLines(filmIndexes, currentFilmIndex, heroVideo, mobileOffset);
        }, mobileAnimation);
      } else {
        this.drawLines(filmIndexes, currentFilmIndex, heroVideo, mobileOffset);
      }
    }
  }

  drawLines(filmIndexes, currentFilmIndex, heroVideo, mobileOffset) {
    let pathStr;
    let indexDistances = filmIndexes.map(filmIndex => Math.abs(filmIndex - currentFilmIndex));
    let maxIndexDistance = Math.max(...indexDistances);
    let maxOffsetX = heroVideo.getBoundingClientRect().left - (this.$refs.listView as any).getBoundingClientRect().left;

    let posVideo = {
      x: heroVideo.getBoundingClientRect().left - mobileOffset,
      y: heroVideo.getBoundingClientRect().top + window.pageYOffset + (heroVideo.getBoundingClientRect().height / 2),
    };

    filmIndexes.forEach((itemIndex, index) => {
      let currentOffset = maxOffsetX * indexDistances[index] / maxIndexDistance;
      let item = this.$refs[`film-${itemIndex}`][0];

      let itemPos = {
        x: item.getBoundingClientRect().left,
        y: item.getBoundingClientRect().top + window.pageYOffset + (item.getBoundingClientRect().height / 2),
      };

      if (this.isMobile) {
        pathStr = "M" +
          (posVideo.x) + "," + (posVideo.y) + " " +
          "C" +
          (posVideo.x) + "," + (posVideo.y + ((itemPos.y - posVideo.y) / 2))+ " " +
          (itemPos.x - ((itemPos.x - posVideo.x) / 2)) + "," + itemPos.y + " " +
          (itemPos.x) + "," + (itemPos.y);
      } else {
        pathStr = "M" +
          (posVideo.x) + "," + (posVideo.y) + " " +
          "C" +
          (posVideo.x - currentOffset) + "," + posVideo.y + " " +
          (itemPos.x - currentOffset) + "," + itemPos.y + " " +
          (itemPos.x) + "," + (itemPos.y);
      }

      let weight = 1;
      const connectedFilmId = this.arrayFilms[itemIndex].id;
      const connectedLine = this.arrayFilms[currentFilmIndex].connectionWith.find(line => line.id === connectedFilmId);
      if (connectedLine) {
        weight = connectedLine.weight;
      }
      let line = {
        path: pathStr,
        weight,
      };

      this.connectionLines.push(line);
    });
  }

  findIndexByID(filmID) {
    return this.filteredFilms.findIndex(film => film.id === filmID);
  }

  itemClick(film: Film.IFilm, index: number) {
    if (this.clickIndex === index) {
      if (this.isKiosk) {
        this.$store.dispatch('rhizome/openFilmModal', { filmId: film.id })
      } else {
        this.$store.dispatch('routerStore/openFilmPage', film.id);
      }
    }

    this.clickIndex = index;

    this.removeLines();
    this.removeConnections();

    this.addLines(film, index);
  }

  itemMouseEnter(film: Film.IFilm, index: number) {
    if (this.isMobile) return;

    this.hoverIndex = index;

    if (this.clickIndex === null) this.addLines(film, index);
  }

  itemMouseLeave() {
    this.hoverIndex = null;

    if (this.clickIndex === null) this.removeLines();
  }

  removeLines() {
    this.connectionLines = [];
  }

  checkConnections(index) {
    if (this.clickIndex !== null) return this.connectedFilms.includes(index);
  }

  removeConnections() {
    this.connectedFilms = [];
  }

  clearLineConnections() {
    this.clickIndex = null;

    this.removeLines();
    this.removeConnections();
  }

  clearOnMobile() {
    this.filteredFilms = this.arrayFilms;
    this.clearLineConnections();
  }

  @Watch('showFavorites')
  onShowFavoritesChange() {
    this.prepareListFilms();
  }

  destroyed() {
    window.removeEventListener('resize', this.resizeEvent);
    bus.$off('filterList');
    bus.$off('filterListKeyword');
  }
}
